import { useTranslation } from 'react-i18next';
import { ExternalLink } from '../../assets/icons';
import { IconSize } from '../../constant/IconSize.constant';
import { useCompany } from '../../hooks/useCompany';
import { useLicenseRenewalResultFromStorage } from '../../hooks/useLicenseRenewalResultFromStorage';
import { useSelfServeRenewLicenseMutation } from '../../services/license.api';
import { SCOPE_TYPE } from '../../services/utils';
import { LicenseSelfServeRenewal } from '../../stores/types/licenses.interface';
import {
  Button,
  ButtonSize,
  ButtonType,
  ColorType,
  Label,
  LabelType,
  useGlobalModalContext,
} from '../_ui';
import { Form } from '../_ui/Form.component';

const SelfServeRenewalCheckout = ({ renewals }: { renewals: Array<LicenseSelfServeRenewal> }) => {
  const { t } = useTranslation();
  const { userScope, companyId } = useCompany();
  const [triggerSelfServeRenewLicenses, selfServeRenewLicensesResult] =
    useSelfServeRenewLicenseMutation();
  const { storeRenewalResult } = useLicenseRenewalResultFromStorage();

  const { hideModal } = useGlobalModalContext();

  const handleRenewalCheckoutClick = () => {
    triggerSelfServeRenewLicenses({
      params: {
        scope: userScope || SCOPE_TYPE.COMPANY,
        companyId: companyId || '',
      },
      body: { licenses: renewals },
    });
  };

  return (
    <Form
      onSubmit={handleRenewalCheckoutClick}
      queryResult={selfServeRenewLicensesResult}
      onQuerySuccess={() => {
        if (selfServeRenewLicensesResult.data) {
          storeRenewalResult(
            selfServeRenewLicensesResult.data.renewal.renewalId,
            selfServeRenewLicensesResult.data.renewal.licenses,
          );
          window.open(selfServeRenewLicensesResult.data.stripeCheckoutRedirectUrl);
        }
        hideModal();
      }}
      onQueryFailed={() => {
        hideModal();
      }}
    >
      <Label
        type={LabelType.BODY3}
        color={ColorType.BLACK}
        text={t('proceed_to_stripe_subtitle')}
        className='mb-6'
      />
      <Button
        label={t('proceed_to_stripe_button')}
        size={ButtonSize.MEDIUM_FULL}
        type={ButtonType.PRIMARY}
        iconAlt={t('proceed_to_stripe_button')}
        labelIcon={ExternalLink}
        labelIconSize={IconSize.SIZE_20x20}
        labelIconColor={ColorType.WHITE}
        labelContainerCss='label-flex-g-0'
        className='mb-5'
        isSumbit
      />
    </Form>
  );
};

export default SelfServeRenewalCheckout;
